import TextButton from 'components/TextButton';
import styled from 'styled-components';

export const Button = styled(TextButton)`
  font-family: Roboto, Helvetica, Arial, sans-serif;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: normal;
  text-transform: none;
`;
